import { BackupInterval } from "./BackupInterval"
import { RetentionPeriod } from "./RetentionPeriod"

export class Backup{
    id!: string

    backupLocation!: string
    created!: Date
}